<template>
  <feature-config />
</template>

<script>
  import FeatureConfig from '../components/FeatureConfig.vue'

  export default {
    components: {
      FeatureConfig,
    },
  }
</script>
